export default "__VITE_ASSET__LD7Z5_Wv__"